// js/util/geom.js
// 極簡 2D 向量與幾何工具。所有座標為「格」單位（容許小數）。

export function clamp(v, lo, hi) { return v < lo ? lo : v > hi ? hi : v; }

export function dist(ax, ay, bx, by) { return Math.hypot(ax - bx, ay - by); }

// 點 P 到線段 AB 的距離
export function distSeg(px, py, ax, ay, bx, by) {
  const dx = bx - ax, dy = by - ay;
  const l2 = dx * dx + dy * dy;
  if (l2 === 0) return Math.hypot(px - ax, py - ay);
  let t = ((px - ax) * dx + (py - ay) * dy) / l2;
  t = clamp(t, 0, 1);
  return Math.hypot(px - (ax + t * dx), py - (ay + t * dy));
}

// 線段 AB 與 CD 是否相交，回傳交點或 null
export function segSeg(ax, ay, bx, by, cx, cy, dx, dy) {
  const r1 = bx - ax, r2 = by - ay;
  const s1 = dx - cx, s2 = dy - cy;
  const denom = r1 * s2 - r2 * s1;
  if (denom === 0) return null;
  const t = ((cx - ax) * s2 - (cy - ay) * s1) / denom;
  const u = ((cx - ax) * r2 - (cy - ay) * r1) / denom;
  if (t >= 0 && t <= 1 && u >= 0 && u <= 1) {
    return { x: ax + t * r1, y: ay + t * r2 };
  }
  return null;
}

// 射線法判斷點是否在多邊形內。poly = [{x,y}, ...]
export function pointInPoly(px, py, poly) {
  let inside = false;
  for (let i = 0, j = poly.length - 1; i < poly.length; j = i++) {
    const xi = poly[i].x, yi = poly[i].y, xj = poly[j].x, yj = poly[j].y;
    const hit = ((yi > py) !== (yj > py)) &&
      (px < ((xj - xi) * (py - yi)) / (yj - yi + 1e-12) + xi);
    if (hit) inside = !inside;
  }
  return inside;
}

// 線段 AB 是否穿越多邊形任一邊
export function segCrossesPoly(ax, ay, bx, by, poly) {
  for (let i = 0, j = poly.length - 1; i < poly.length; j = i++) {
    if (segSeg(ax, ay, bx, by, poly[j].x, poly[j].y, poly[i].x, poly[i].y)) return true;
  }
  return false;
}
